var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiabetes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Select-Area-Circle--Streamline-Freehand.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Select Area Circle Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.71 9.32A4 4 0 0 0 11.46 8a3.82 3.82 0 0 0 -3 1.78A3.37 3.37 0 0 0 8 11.25a4 4 0 0 0 0.13 1.56 3.09 3.09 0 0 0 0.45 1 2 2 0 0 0 0.57 0.55 0.33 0.33 0 0 0 0.43 -0.08 0.32 0.32 0 0 0 -0.09 -0.43 1.35 1.35 0 0 1 -0.49 -0.5 3.14 3.14 0 0 1 -0.22 -0.72 3.28 3.28 0 0 1 0 -1.26 2.52 2.52 0 0 1 0.48 -1.1 2.89 2.89 0 0 1 2.26 -1.18 2.92 2.92 0 0 1 2.31 1 2.76 2.76 0 0 1 0.52 2.85 2.93 2.93 0 0 1 -2.46 1.75 4.43 4.43 0 0 1 -0.72 0 3.1 3.1 0 0 1 -0.7 -0.11 0.34 0.34 0 1 0 -0.22 0.65 3.47 3.47 0 0 0 0.86 0.19 4.9 4.9 0 0 0 0.86 0 3.78 3.78 0 0 0 3.3 -2.12 3.83 3.83 0 0 0 -0.56 -3.98Z",
    fill: "#B557F7",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47 19.48 3.06 19a4.69 4.69 0 0 1 -0.42 -0.46 4.78 4.78 0 0 1 -0.37 -0.54 0.34 0.34 0 0 0 -0.44 -0.19 0.33 0.33 0 0 0 -0.2 0.44 4.41 4.41 0 0 0 0.43 1.27 2.48 2.48 0 0 0 0.78 0.88A6.5 6.5 0 0 0 4 21a0.31 0.31 0 0 0 0.42 -0.09 0.32 0.32 0 0 0 -0.08 -0.42 11.72 11.72 0 0 1 -0.87 -1.01Z",
    fill: "#8841B9",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.13 20.82a5.22 5.22 0 0 1 -0.54 0.37 4.75 4.75 0 0 1 -0.55 0.28l-0.55 0.26c-0.35 0.18 -0.7 0.41 -1.19 0.63a0.29 0.29 0 0 0 -0.23 0.36 0.31 0.31 0 0 0 0.36 0.23 6.24 6.24 0 0 0 1.3 -0.11 2 2 0 0 0 0.55 -0.2 2.41 2.41 0 0 0 0.5 -0.33 4.27 4.27 0 0 0 0.86 -1 0.35 0.35 0 0 0 0 -0.49 0.36 0.36 0 0 0 -0.51 0Z",
    fill: "#8841B9",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.17 13.82c0 -0.11 0 -0.23 -0.08 -0.35 -0.08 -0.28 -0.18 -0.54 -0.27 -0.85a0.35 0.35 0 1 0 -0.69 0 8.62 8.62 0 0 0 -0.13 0.93A2.55 2.55 0 0 0 0 14a1.3 1.3 0 0 0 0.09 0.4 4.07 4.07 0 0 0 0.43 0.85 0.3 0.3 0 0 0 0.37 0.22 0.31 0.31 0 0 0 0.22 -0.37c0 -0.2 0.06 -0.49 0.07 -0.89a2.4 2.4 0 0 0 -0.01 -0.39Z",
    fill: "#8841B9",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.32 16.9a0.34 0.34 0 0 0 -0.45 0.17c-0.19 0.26 -0.39 0.47 -0.56 0.7l-0.2 0.3a2.45 2.45 0 0 0 -0.16 0.33c-0.15 0.38 -0.19 0.66 -0.26 0.86a0.3 0.3 0 0 0 0.49 0.35 4.32 4.32 0 0 0 0.72 -0.61 2.1 2.1 0 0 0 0.22 -0.33 2.06 2.06 0 0 0 0.16 -0.37c0.09 -0.29 0.15 -0.58 0.22 -0.92a0.35 0.35 0 0 0 -0.18 -0.48Z",
    fill: "#8841B9",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.68 9.75a0.32 0.32 0 0 0 0.37 -0.23c0.19 -0.47 0.47 -0.9 0.7 -1.39 0.13 -0.27 0.24 -0.55 0.35 -0.83s0.32 -0.85 0.54 -1.28a0.34 0.34 0 0 0 -0.56 -0.4 8.15 8.15 0 0 0 -0.93 1.14 4.4 4.4 0 0 0 -0.31 0.56 3 3 0 0 0 -0.21 0.6 7.47 7.47 0 0 0 -0.18 1.46 0.32 0.32 0 0 0 0.23 0.37Z",
    fill: "#8841B9",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91 1.52a0.35 0.35 0 0 0 0.23 -0.43 0.35 0.35 0 0 0 -0.43 -0.23 9.1 9.1 0 0 0 -1.62 0.39 4.84 4.84 0 0 0 -0.66 0.28 4.41 4.41 0 0 0 -0.62 0.37A8.73 8.73 0 0 0 4.59 3a0.31 0.31 0 1 0 0.41 0.52c0.5 -0.31 1 -0.52 1.58 -0.76l0.92 -0.49a15.89 15.89 0 0 1 1.41 -0.75Z",
    fill: "#8841B9",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.23 1a16.41 16.41 0 0 1 2 0.45l1 0.21c0.33 0.07 0.66 0.12 1 0.2s0.66 0.18 1 0.3a0.34 0.34 0 0 0 0.3 -0.62 9.52 9.52 0 0 0 -1.78 -0.89A5.16 5.16 0 0 0 15 0.41a5.47 5.47 0 0 0 -0.81 -0.13 9.56 9.56 0 0 0 -1.92 0.11 0.3 0.3 0 1 0 0 0.6Z",
    fill: "#8841B9",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.08 5.5a4.68 4.68 0 0 0 -0.3 -0.54 4.57 4.57 0 0 0 -0.38 -0.49 7.44 7.44 0 0 0 -1.13 -0.9 0.3 0.3 0 0 0 -0.43 0.43c0.3 0.41 0.5 0.86 0.77 1.3 0.16 0.25 0.34 0.49 0.51 0.73s0.55 0.71 0.79 1.1a0.35 0.35 0 0 0 0.45 0.19 0.36 0.36 0 0 0 0.19 -0.46 9.1 9.1 0 0 0 -0.47 -1.36Z",
    fill: "#8841B9",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 11.36a7.65 7.65 0 0 0 -0.41 -1.47 0.3 0.3 0 0 0 -0.35 -0.25 0.32 0.32 0 0 0 -0.24 0.36c0 0.55 -0.09 1.07 -0.11 1.61l0 1a13.83 13.83 0 0 1 0 1.44 0.34 0.34 0 0 0 0.27 0.41 0.35 0.35 0 0 0 0.41 -0.26 9.43 9.43 0 0 0 0.41 -1.47A4.78 4.78 0 0 0 24 12a4.86 4.86 0 0 0 0 -0.64Z",
    fill: "#8841B9",
    fillRule: "evenodd",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.74 22.9c-0.59 -0.07 -1.13 -0.22 -1.69 -0.31 -0.33 -0.05 -0.67 -0.08 -1 -0.11 -0.52 -0.05 -1 -0.07 -1.52 -0.16a0.34 0.34 0 1 0 -0.21 0.65 8.37 8.37 0 0 0 1.49 0.58 5.12 5.12 0 0 0 0.68 0.14 3.82 3.82 0 0 0 0.68 0 8.7 8.7 0 0 0 1.58 -0.22 0.3 0.3 0 0 0 0.29 -0.31 0.32 0.32 0 0 0 -0.3 -0.26Z",
    fill: "#8841B9",
    fillRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiabetes);
export default __webpack_public_path__ + "static/media/diabetes.2b368ffbe7c1ec68539d6a93c22819e4.svg";
export { ForwardRef as ReactComponent };